module.exports = __webpack_public_path__ + "img/6.235c3ae2.png";